var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78333 8.04967L6.18333 5.44967C6.06111 5.32745 6 5.1719 6 4.98301C6 4.79412 6.06111 4.63856 6.18333 4.51634C6.30556 4.39412 6.46111 4.33301 6.65 4.33301C6.83889 4.33301 6.99444 4.39412 7.11667 4.51634L10.1833 7.58301C10.25 7.64967 10.2972 7.7219 10.325 7.79967C10.3528 7.87745 10.3667 7.96079 10.3667 8.04967C10.3667 8.13856 10.3528 8.2219 10.325 8.29967C10.2972 8.37745 10.25 8.44967 10.1833 8.51634L7.11667 11.583C6.99444 11.7052 6.83889 11.7663 6.65 11.7663C6.46111 11.7663 6.30556 11.7052 6.18333 11.583C6.06111 11.4608 6 11.3052 6 11.1163C6 10.9275 6.06111 10.7719 6.18333 10.6497L8.78333 8.04967Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBlack);
export default __webpack_public_path__ + "static/media/chevron_black.03fbd0be2cedc8a2eacc82a6d9e6fffe.svg";
export { ForwardRef as ReactComponent };